//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    computed: {
        tidalSupportHref() {
            return `${process.env.TIDAL_ORIGIN}/help`;
        },
        myTidalHref() {
            return `${process.env.MY_TIDAL_ORIGIN}/login?noRedirect=true` || '';
        },
    },
};
